import _parseInt from "/Users/jhonsem/Work/FaceAnalysis_Web/node_modules/@babel/runtime-corejs2/core-js/parse-int";
import "core-js/modules/es6.regexp.split";
import { isIos } from "./lodash";
/*
 * JavaScript实现版本号比较
 * 传入两个字符串，当前版本号：curV；比较版本号：reqV
 */

export var judgeVersion = function judgeVersion(curV, reqV, equal) {
  if (curV && reqV) {
    var curArr = curV.split(".");
    var reqArr = reqV.split("."); // 将版本号拆成数字

    var minL = Math.min(curArr.length, reqArr.length);
    var pos = 0; // 当前比较的位数

    var diff = 0; // 当前位数是否相等
    //逐个比较如果当前位相等则继续比较下一位

    while (pos < minL) {
      diff = _parseInt(curArr[pos]) - _parseInt(reqArr[pos]);

      if (diff !== 0) {
        break;
      }

      pos++;
    } // console.log("diff", diff);


    return equal ? diff >= 0 : diff > 0;
  } else {
    return false;
  }
};
/**
 * 获取原生的版本号
 */

export var getCodeVersion = function getCodeVersion() {
  if (window.device && window.device.codeVersion) {
    return window.device.codeVersion;
  } else {
    return window.device && window.device.appVersion;
  }
};
/*
 * futureBaby版本控制 > 1.1.0
 * */

export var judgeFutureBabyVersion = function judgeFutureBabyVersion() {
  var current_version = getCodeVersion();
  return judgeVersion(current_version, "1.1.0", true);
};
/**
 * 新版本由web显示guide > 1.1.0
 */

export var judgeCameraGuide = function judgeCameraGuide() {
  var current_version = getCodeVersion();
  return judgeVersion(current_version, "1.1.0", true);
};
/**
 * 用来判断本地视频和启动参数 > 1.2.0
 */

export var judgeLocalVideoAndConfig = function judgeLocalVideoAndConfig() {
  var current_version = getCodeVersion();
  return judgeVersion(current_version, "1.2.0", true);
};
/**
 * 用来判断是否支持震动 > 1.3.0
 */

export var judgeAppSurportVibrate = function judgeAppSurportVibrate() {
  var current_version = getCodeVersion();
  return judgeVersion(current_version, "1.3.0", true);
};
/**
 * 用来判断是否是ios，并且 >= 1.6.0，原生拍照界面支持人脸检测
 */

export var judgeIsIosAndIsNewCamera = function judgeIsIosAndIsNewCamera() {
  if (!isIos()) {
    return false;
  }

  var current_version = getCodeVersion();
  return judgeVersion(current_version, "1.6.0", true);
};